module.exports = __webpack_public_path__ + "img/22.d5e5ee5b.png";